import React from 'react';

const partners = [
  {
    name: 'Empire Summit',
    logo: '/images/partner-empire-summit.png',
  },
  {
    name: 'NT Development Group',
    logo: '/images/partner-nt-development-group.png',
  },
];

const ClientsSection = () => {
  return (
    <section id="clients" className="relative z-10 max-w-6xl mx-auto px-6 py-20">
      <div className="text-center mb-14">
        <div className="text-xs uppercase tracking-[0.25em] text-[#8b5a2b] font-medium mb-4">Partners</div>
        <h2 className="text-4xl md:text-5xl font-semibold tracking-[-0.025em] text-[#2a2420]">
          Those we <span className="font-serif-display italic font-medium text-[#8b5a2b]">stand beside.</span>
        </h2>
      </div>

      <div className="flex flex-wrap justify-center items-stretch gap-5 mb-12">
        {partners.map((p) => (
          <div
            key={p.name}
            className="group relative rounded-2xl bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_-12px_rgba(80,50,20,0.12)] hover:shadow-[0_16px_48px_-12px_rgba(80,50,20,0.2)] hover:bg-white/80 transition-all duration-500 px-10 py-6 min-w-[240px] flex flex-col items-center justify-center"
          >
            <div className="h-16 flex items-center justify-center mb-3">
              <img
                src={p.logo}
                alt={p.name}
                className="max-h-14 max-w-[180px] object-contain opacity-80 group-hover:opacity-100 transition-opacity"
              />
            </div>
            <span className="text-[#2a2420] text-sm font-medium">{p.name}</span>
          </div>
        ))}
      </div>

      {/* NT Government partner */}
      <div className="flex justify-center">
        <div className="inline-flex items-center gap-6 rounded-2xl bg-white/60 backdrop-blur-xl border border-white/80 shadow-[0_8px_32px_-12px_rgba(80,50,20,0.12)] px-8 py-5">
          <img
            src="/images/partner-nt-government.png"
            alt="NT Government"
            className="h-14 w-auto object-contain"
          />
          <div className="text-left border-l border-[#8b5a2b]/20 pl-6">
            <p className="text-[#8b5a2b] text-[10px] uppercase tracking-[0.2em] font-medium mb-0.5">Proud partner</p>
            <p className="text-[#2a2420] text-base font-medium">NT Government</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
